import axios from "axios";
import { getUrl } from "./urls";
import { getAccessToken, getCompanyId } from "./utils";
import { toast } from "react-toastify";

export const FETCH_USER_ACTIVITY_LOGS = "FETCH_USER_ACTIVITY_LOGS";
export const FETCH_USER_ACTIVITY_LOGS_PENDING = "FETCH_USER_ACTIVITY_LOGS_PENDING";
export const FETCH_USER_ACTIVITY_LOGS_FULFILLED = "FETCH_USER_ACTIVITY_LOGS_FULFILLED";
export const FETCH_USER_ACTIVITY_LOGS_REJECTED = "FETCH_USER_ACTIVITY_LOGS_REJECTED";
export const UPDATE_DURATION = "UPDATE_DURATION";
export const COMPANY_USERS = "COMPANY_USERS";
export const UPDATE_INITIAL_FILTERS = "UPDATE_INITIAL_FILTERS";
export const UPDATE_FILTERS = "UPDATE_FILTERS";
// export const CLEANUP_USER_ACTIVITY = "CLEANUP_USER_ACTIVITY";

export const fetchUserActivityLogs = (data) => {
    return (dispatch) => {
        dispatch({ type: "FETCH_USER_ACTIVITY_LOGS_PENDING" });

        let url = `${getUrl("user_service")}/activity/log/search`;
        let { pagination } = data;

        let req = axios({
            method: "post",
            url,
            data,

            headers: {
                "Content-Type": "application/json",
                "access-token": getAccessToken(),
            },
        })
            .then((res) => {
                // console.log("resss", res.data?.data);
                dispatch({
                    type: "FETCH_USER_ACTIVITY_LOGS_FULFILLED",
                    payload: { ...res.data?.data, pagination },
                });
                // return { ...res.data?.data, pagination };
            })
            .catch((err) => {
                console.log(err, err.message);
                dispatch({
                    type: "FETCH_USER_ACTIVITY_LOGS_REJECTED",
                    payload: err.message,
                });
                return err;
            });
    };

    // return {
    //     type: FETCH_USER_ACTIVITY_LOGS,
    //     payload: req,
    // };
};

// export const updateDuration = (payload) => ({
//     type: UPDATE_DURATION,
//     payload,
// });

export const updateFilters = (payload) => ({
    type: UPDATE_FILTERS,
    payload,
});

export const getAllUsers = () => {
    return async (dispatch) => {
        const userType = "user,admin,companyadmin,token_provider";
        try {
            dispatch({ type: "COMPANY_USERS_PENDING" });
            const response = await axios.get(`${getUrl("company_service")}/${getCompanyId()}/users?access-token=${getAccessToken()}&userTypes=${userType}`, {
                headers: {
                    "Content-Type": "application/json",
                },
            });

            dispatch({ type: "COMPANY_USERS_FULFILLED", payload: response.data?.data?.users || [] });
        } catch (err) {
            dispatch({ type: "COMPANY_USERS_REJECTED" });
            toast.error(err.response?.data?.message || "Some error occured in fetching users lists.");
        }
    };
};

export const updateInitialFilters = (payload) => ({ type: UPDATE_INITIAL_FILTERS, payload });
// export const cleanupUserActivity = () => ({ type: CLEANUP_USER_ACTIVITY });
